import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const knock = defineConnector({
  identifier: "knock",
  name: "Knock",
  tagLine: "Notifications infrastructure",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api\\.knock\\.app/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your secret API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Knock dashboard](https://dashboard.knock.app/), open **Developers › API keys** and copy the secret key for your environment.",
        },
      ],
    },
    {
      title: "Paste your secret key",
      items: [
        {
          kind: "input",
          label: "Secret key",
          placeholder: "sk_...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.knock.app/v1/users?page_size=1",
  },
});
